module.exports = __webpack_public_path__ + "img/HOME-4.1c8fbe17.png";